// Generated by CoffeeScript 1.12.7
require.config({
  baseUrl: '/javascript/libs',
  enforceDefine: false,
  waitSeconds: 120,
  paths: {
    collections: '../collections',
    etc: '../etc',
    models: '../models',
    views: '../views',
    templates: '../../templates',
    underscore: 'lodash',
    cloudinary: 'cloudinary/cloudinary-core-shrinkwrap',
    maskedInput: 'jquery.maskedinput',
    text: 'require_plugins/text',
    propertyParser: 'require_plugins/propertyParser'
  }
});

define('../main',['require','jquery','underscore','views/survey_view'],function(require) {
  var $, SurveyView, _;
  window.DEBUG = false;
  if (!window.console) {
    window.console = {
      log: function() {},
      error: function() {}
    };
  }
  $ = require('jquery');
  _ = require('underscore');
  SurveyView = require("views/survey_view");
  return $(document).ready(function() {
    var language, surveyView;
    surveyView = new SurveyView({
      data: GLOBALS.data,
      version: GLOBALS.version,
      env: GLOBALS.env
    });
    language = _.get(GLOBALS, ['data', 'language', 'code']);
    surveyView.on(SurveyView.UNAVAILABLE_EVENT, function() {
      var redirect;
      surveyView.destroyListeners();
      redirect = "/unavailable?lang=" + language;
      return window.location.href = redirect;
    });
    surveyView.on(SurveyView.FORBIDDEN_EVENT, function() {
      var redirect;
      surveyView.destroyListeners();
      redirect = "/completed?lang=" + language;
      return window.location.href = redirect;
    });
    return surveyView.render();
  });
});

